import React, { useRef } from 'react';
import '../../../Assets/Css/EmployeeTask.scss';
import Table from '../../../Components/Table';
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import { useEffect } from 'react';
import { customStyle } from '../../../Components/Style';
import { useState } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import qs from 'query-string';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import CustomCalendar from '../../../Components/CustomCalendar';
import TaskIcon from '../../../Assets/Images/Task/taskicon';
import TaskBoardIcon from '../../../Assets/Images/Task/taskboard';
import TaskCalendarIcon from '../../../Assets/Images/Task/taskcalendar';
import { getTasks, getTaskStatus, updateTask } from '../../../Services/Task/action';
import { getTime } from '../../../Lib/utils';
import moment from 'moment';
import { deleteRecord } from '../../../Services/Delete/action';
import useTimerStore from '../../../Lib/timerStore';
import { exportData } from '../../../Lib/exportData';
import ModulesList from '../../../Assets/ModulesLiist';
import FeaturesList from '../../../Assets/FeaturesList';
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../../Lib/RoleWiseFeatureWrapper';
import Skeleton from 'react-loading-skeleton';
import { getDashboardData } from '../../../Services/Dashboard/action';
import { getprojects } from '../../../Services/Project/action';

const EmpTask = (props) => {
  const [checked, setChecked] = useState(false);
  const [params, setParams] = useState({});
  const [totalSelectedIds, setTotalSelectedIds] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [inData, setInData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [activeButton, setActiveButton] = useState('');
  const { updateTimer } = useTimerStore()

  const fileInputRef = useRef(null);
  const modalRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const canView = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Task,
    Featur_Name: FeaturesList.View,
  });

  const canDelete = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Task,
    Featur_Name: FeaturesList.Delete,
  });
  const canEdit = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Task,
    Featur_Name: FeaturesList.Update,
  });

  const header = [
    { field: 'checkbox' },
    { field: 'Code' },
    { field: 'Timer' },
    { field: 'Time' },
    { field: 'Task' },
    { field: 'Project' },
    { field: 'Start Date' },
    { field: 'Due Date' },
    { field: 'Hours Logged' },
    { field: 'Assigned To' },
    { field: 'Status' },
    { field: 'Action' },
  ];

  let footer = true;
  let count = inData?.length;

  useEffect(() => {
    const fetchDataAsync = async () => {
      await fetchData();
    };

    fetchDataAsync();
  }, [location.search]);

  const fetchData = async () => {
    try {
      setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
      await props.getTasks();
      await props?.getTaskStatus();
      await props?.getprojects();
    } catch (error) {
      console.error('Error fetching task list:', error);
    }
  };

  useEffect(() => {
    if (location.pathname == '/task/emptask') {
      const path = location.pathname.slice(6);
      setActiveButton(path);
    } else if (location.pathname == '/task/emptaskboard') {
      const path = location.pathname.slice(6);
      setActiveButton(path);
    } else if (location.pathname == '/task/emptaskcalendar') {
      const path = location.pathname.slice(6);
      setActiveButton(path);
    }
  }, []);

  const clickButton = (buttonId, route) => {
    setActiveButton(buttonId);
    navigate(route);
  };

  const Status = props?.taskStatus?.map((item) => {
    return { value: item?.name, label: item?.name, color: item?.color_code, taskStatus: item?.taskStatus, createdAt: item?.createdAt }
  })

  const isTimerRunning = (assignedUserIds, currentUserRole, allTasks) => {

    const allRunningTimers = allTasks
      ?.flatMap(task => task?.taskTimerMap || [])
      ?.filter(timer => timer?.state !== "stopped");

    if (currentUserRole === "hr_senior") {
      return allRunningTimers.some(t => assignedUserIds?.includes(t?.employee_id));
    }

    return allRunningTimers.some(t => assignedUserIds?.includes(t?.employee_id) && t?.state != "stopped");
  };

  useEffect(() => {
    const userId = props?.user?.id;

    const assignedProjectIds = props?.project
      ?.filter(project =>
        project?.projectUserMap?.some(item =>
          item?.userProjectMap?.id === userId
        )
      )
      ?.map(project => project.id) || [];

    const assignedTasks = props?.task?.filter(task =>
      assignedProjectIds.includes(task?.project?.id)
    ) || [];
    
    const updateContent = async () => {
      const tasksToProcess = props?.user?.role?.name.toLowerCase() === "employee"
        ? assignedTasks
        : props?.task;

      const content = await Promise.all(
        tasksToProcess?.map((item) => {
          const taskTimers = item?.taskTimerMap?.[0];
          const allTimers = item?.taskTimerMap;

          const actionHistory = typeof taskTimers?.action_history === "string"
            ? JSON.parse(taskTimers?.action_history)
            : taskTimers?.action_history || [];
          const { time, hoursLogged } = getTime(
            taskTimers?.start_time,
            taskTimers?.stop_time,
            actionHistory,
          )
          let totalElapsedTime = 0;
          allTimers?.forEach((timer) => {
            if (timer?.duration) {
              const [hh, mm, ss] = timer?.duration?.split(/[hms\s]+/).filter(Boolean).map(Number);
              totalElapsedTime += hh * 3600 + mm * 60 + ss;
            }
          });

          const totalH = Math.floor(totalElapsedTime / 3600);
          const totalM = Math.floor((totalElapsedTime % 3600) / 60);
          const totalS = totalElapsedTime % 60;
          const totalHoursLogged = `${totalH}h ${totalM}m ${totalS}s`;

          return {
            checkbox: {
              value: item?.id,
              value2: item?.taskTimerMap?.find(timer => timer?.state != "stopped")?.id,
              type: "checkbox",
            },
            Code: {
              value: `CD_${item?.id}`,
              type: 'emptext',
            },
            Timer: (() => {
              if (item?.status != "Approved" && item?.status != "Completed") {

                if (props?.user?.role?.name !== "hr_senior") {
                  return {
                    value: item?.taskUserMap?.some(user => user.user_id == props?.user?.id) ?
                      allTimers?.find((timer) => timer?.employee_id === props?.user?.id && timer?.state != "stopped")
                        ? allTimers?.find((timer) => timer?.employee_id === props?.user?.id && timer?.state != "stopped")?.state
                        : '' : '--',
                    type: 'taskstartstop',
                  };
                }

                const assignedUsers = item?.taskUserMap || [];
                if (assignedUsers?.length > 1) {
                  return {
                    value: '--',
                    type: 'taskstartstop'
                  }

                }
                const latestTimer = allTimers?.find(timer => timer?.state != "stopped");
                return {
                  value: latestTimer?.state || '',
                  type: 'taskstartstop',
                };
              }
              else {
                return {
                  value: '--',
                  type: 'taskstartstop'
                }
              }
            })(),

            Time: (() => {
              let totalElapsed = 0;
              let isRunning = false;

              const activeTimers = allTimers?.filter(
                timer => timer?.state !== "stopped" && timer?.task_id === item?.id
              ) || [];
              const assignedUsers = item?.taskUserMap || [];
              if (assignedUsers?.length > 1) {
                if (activeTimers?.length > 1) {
                  return {
                    value: "2 Active Timers",
                    type: 'emptasktimer'
                  }
                }
                else if (activeTimers?.length == 1) {
                  return {
                    value: "1 Active Timer",
                    type: 'emptasktimer'
                  }
                }
              }

              allTimers?.forEach(timer => {
                if (timer?.task_id === item?.id) {
                  let timerElapsed = 0;
                  let currentSessionStart = null;
                  let currentPauseStart = null;

                  if (timer?.state === "running") {
                    isRunning = true;
                  }

                  let actions = [];
                  try {
                    const history = timer?.action_history;
                    actions = typeof history === 'string' ? JSON.parse(history) : (history || []);
                  } catch (error) {
                    console.error("Failed to parse action_history:", error);
                    actions = [];
                  }

                  let parsedActions = [];
                  if (typeof actions === 'string') {
                    try {
                      parsedActions = JSON.parse(actions);
                    } catch (err) {
                      console.error("Failed to parse actions string:", err);
                      parsedActions = [];
                    }
                  } else {
                    parsedActions = Array.isArray(actions) ? actions : [];
                  }
                  parsedActions
                    ?.sort((a, b) => moment(a.time).diff(moment(b.time)))
                    ?.forEach(action => {
                      const actionTime = moment(action.time);

                      if (action.action === 'start' || action.action === 'resume') {
                        currentSessionStart = actionTime;
                        currentPauseStart = null;
                      }
                      else if (action.action === 'pause') {
                        if (currentSessionStart) {
                          timerElapsed += moment.duration(actionTime.diff(currentSessionStart)).asSeconds();
                        }
                        currentPauseStart = actionTime;
                        currentSessionStart = null;
                      }
                      else if (action.action === 'stop') {
                        if (currentSessionStart) {
                          timerElapsed += moment.duration(actionTime.diff(currentSessionStart)).asSeconds();
                        }
                        currentSessionStart = null;
                        currentPauseStart = null;
                      }
                    });
                  if (currentSessionStart && timer?.state === "running") {
                    timerElapsed += moment.duration(moment().diff(currentSessionStart)).asSeconds();
                  }
                  if (timer?.elapsed_time) {
                    timerElapsed += timer.elapsed_time;
                  }

                  totalElapsed += timerElapsed;
                }
              });
              const h = String(Math.floor(totalElapsed / 3600)).padStart(2, '0');
              const m = String(Math.floor((totalElapsed % 3600) / 60)).padStart(2, '0');
              const s = String(Math.floor(totalElapsed % 60)).padStart(2, '0');
              const formattedTime = (!isRunning && totalElapsed == 0) ? '--' : `${h}:${m}:${s}`;
              const type = (!isRunning && totalElapsed == 0) ? 'emptext' : 'emptasktimer';

              return {
                value: formattedTime,
                type: type
              };
            })(),
            Task: {
              value: item?.title,
              type: 'emptext',
            },
            Project: {
              value: item?.project?.name || '--',
              type: 'emptext',
            },
            'Start Date': {
              value: item?.start_date?.split(" ")[0],
              type: 'empdate',
            },
            'Due Date': {
              value: item?.due_date?.split(" ")[0] || '--',
              type: 'empdate',
            },
            'Hours Logged': {
              value: totalHoursLogged === "0h 0m 0s" ? '0s' : totalHoursLogged,
              type: 'emptext',
            },
            'Assigned To': {
              value: item?.taskUserMap?.map(user => ({
                name: user?.userTaskMap?.name,
                src: user?.userTaskMap?.profile_pic?.data ? `data:image/png;base64,${btoa(String.fromCharCode(...new Uint8Array(user?.userTaskMap?.profile_pic?.data)))}` : '',
                id: user?.userTaskMap?.id,
                isEmployeeTaskPage: false
              })),
              type: "share holder",
            },
            Status: {
              value: item?.status,
              type: 'status_option',
            },
            Action: {
              value: '/task/emptask/edit',
              value2: `/task/emptask/view/${item?.id}`,
              value3: item?.id,
              showIsEdit: canEdit && (props?.user?.role?.name == "hr_senior" ? true : item?.taskUserMap?.some(item => item?.user_id == props?.user?.id)),
              showIsDelete: canDelete && (props?.user?.role?.name == "hr_senior" ? true : item?.taskUserMap?.some(item => item?.user_id == props?.user?.id)),
              type: 'action',
            },
            allData: {
              ...item,
              taskTimers: taskTimers,
              totalHoursLogged: totalHoursLogged,
              time: time
            },
            user: {
              ...props?.user
            },
            timerIsRunning: {
              value: isTimerRunning(
                item?.taskUserMap?.map(user => user?.userTaskMap?.id) || [],
                props?.user?.role?.name,
                props?.task
              )
            }
          };
        }));
      setInData(content);
      await props?.getDashboardData(props?.user?.id);
    };

    if (props?.task?.length) {
      const updatedTimers = {};
      const validKeys = new Set();

      props?.task?.forEach((item) => {
        const allTimers = item?.taskTimerMap;

        allTimers?.forEach((timer) => {
          const key = `${timer.employee_id}_${timer.task_id}`;
          validKeys.add(key);

          if (
            !updatedTimers[key] ||
            timer.id > (updatedTimers[key].id || 0)
          ) {
            const { time } = getTime(timer.start_time, new Date(), typeof timer.action_history === "string"
              ? JSON.parse(timer.action_history)
              : timer.action_history || []);
            updatedTimers[key] = {
              id: timer.id,
              taskId: timer.task_id,
              startTime: timer.start_time,
              status: timer?.state,
              actionHistory:
                typeof timer.action_history === "string"
                  ? JSON.parse(timer.action_history)
                  : timer.action_history || [],
              timer: time
            };
          }
        });
      });

      const filteredExistingTimers = Object.fromEntries(
        Object.entries(useTimerStore.getState().timers).filter(
          ([key]) => validKeys.has(key)
        )
      );

      const sanitizedTimers = Object.fromEntries(
        Object.entries(updatedTimers).map(([key, value]) => {
          const { id, ...rest } = value;
          return [key, rest];
        })
      );

      useTimerStore.setState({
        timers: {
          ...filteredExistingTimers,
          ...sanitizedTimers,
        },
      });

      updateContent();
    }
  }, [props?.task]);

  const handleClose = () => {
    setShowModal(false);
    setFileName('');
    setSelectedFile(null);
    fileInputRef.current.value = null;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
        setFileName('');
        setSelectedFile(null);
        fileInputRef.current.value = null;
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClose]);

  const handleChange = (event) => {
    const { type, checked, id, ids } = event;

    if (type === "select-all") {
      setTotalSelectedIds(checked ? [...ids] : []);
    } else if (type === "select-one") {
      if (checked) {
        setTotalSelectedIds(prev => [...prev, id]);
      } else {
        setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
      }
    }
  };

  const handleXlsxDownload = (Ids) => {
    const excludedFields = ['checkbox', 'Action', 'Timer', 'Time'];
    const columns = header
      .filter(col => !excludedFields.includes(col.field))
      .map(col => ({
        label: col.field,
        key: col.field
      }));

    const selectedData = inData
      .filter(item => Ids.includes(item.allData?.id))
      .map(row => {
        const newRow = {};

        columns.forEach(({ label, key }) => {
          const cell = row[key];

          if (!cell) {
            newRow[label] = '';
          } else if (key === 'Assigned To' && Array.isArray(cell.value)) {
            newRow[label] = cell.value.map(person => person.name).join(', ');
          } else if (Array.isArray(cell.value)) {
            newRow[label] = cell.value.join(', ');
          } else {
            newRow[label] = cell.value ?? '';
          }
        });

        return newRow;
      });

    exportData({
      data: selectedData,
      columns,
      fileName: 'Task_Report',
      format: 'xlsx',
    });
    setExportLoading(false)
    setTotalSelectedIds([])
  };


  const handleClick = async (totalSelectedIds, type) => {
    let ids = totalSelectedIds.map((id) => parseFloat(id));

    try {
      if (type === 'delete') {
        setDeleteLoading(true);
        await props.deletePurchaseInvoices(ids);
        setChecked(false);
        setTotalSelectedIds([]);
      } else if (type === 'export') {
        setExportLoading(true);
        handleXlsxDownload(ids);
        toast.success('Exported Successfully');
      }
    } catch (error) {
      console.error(error);
    } finally {
      await fetchData();
      setDeleteLoading(false);
    }
  };

  useEffect(() => {
    if (totalSelectedIds.length > 0) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [totalSelectedIds]);

  let path = '/task/emptask/add';
  const handleAddClick = () => {
    navigate(path);
  };

  const initialState = {
    date: '',
    projectStatus: { value: 'Hide Completed Task', label: 'Hide Completed Task' },
  };

  const [clientData, setClientData] = useState(initialState);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState({ value: 'Hide Completed Task', label: 'Hide Completed Task' });
  const [dateStatus, setDateStatus] = useState(false);
  const [isMytaskList, setIsMyTaskList] = useState(false);
  const [filteredStartDate, setFilteredStartDate] = useState(null);
  const [filteredEndDate, setFilteredEndDate] = useState(null);

  const applyFilters = ({ status, search, startDate, endDate }) => {
    setFilteredStartDate(filteredStartDate || startDate);
    setFilteredEndDate(filteredEndDate || endDate);
    const filtered = inData?.filter((task) => {
      let matchesStatus = true;
      let matchesSearch = true;
      let matchesDate = true;
      const taskTitle = task?.Task?.value?.toLowerCase() || '';

      if ((filteredStartDate || startDate) && (filteredEndDate || endDate)) {
        setDateStatus(true);

        const itemStartDate = moment(task?.["Start Date"]?.value).startOf('day');
        const itemDueDate = task?.["Due Date"]?.value
          ? moment(task?.["Due Date"]?.value).startOf('day')
          : itemStartDate;

        const filterStart = moment(filteredStartDate || startDate).startOf('day');
        const filterEnd = moment(filteredEndDate || endDate).endOf('day');

        matchesDate =
          itemStartDate.isBetween(filterStart, filterEnd, undefined, '[]') ||
          itemDueDate.isBetween(filterStart, filterEnd, undefined, '[]');
      }

      if (status && status?.value !== "All") {
        if (status?.value == "Hide Completed Task" && isMytaskList) {
          matchesStatus = task?.["Assigned To"]?.value?.some((user) => user?.id == props?.user?.id) && task?.Status?.value?.toLowerCase() !== "completed";
        }
        else if (status?.value == "Hide Completed Task") {
          matchesStatus = task?.Status?.value?.toLowerCase() !== "completed";

        } else {
          matchesStatus = task?.Status?.value?.toLowerCase() == status?.value?.toLowerCase();
        }
      }
      else if (status?.value == "All" && isMytaskList) {
        matchesStatus = task?.["Assigned To"]?.value?.some((user) => user?.id == props?.user?.id)
      }

      if (search) {
        matchesSearch = taskTitle.includes(search.toLowerCase());
      }
      return matchesStatus && matchesSearch && matchesDate;
    });
    setFilteredData(filtered);
  };
  useEffect(() => {
    if (inData?.length > 0 && selectedStatus) {
      applyFilters({ status: selectedStatus, search: searchTerm });
    }
  }, [inData]);

  const handleSelectStatusChange = (val) => {
    setSelectedStatus(val);
    setClientData((prevVal) => ({
      ...prevVal,
      projectStatus: val,
    }));
    applyFilters({ status: val, search: searchTerm });
  };

  const searchFiled = (e) => {
    const { name, value } = e.target;
    setSearchTerm(value);
    setClientData((preVal) => ({
      ...preVal,
      [name]: value,
    }));
    applyFilters({ status: selectedStatus, search: value });
  };

  const handleFetchUserTasks = () => {
    setIsMyTaskList(true);
    const filtered = inData?.filter((item) => item?.["Assigned To"]?.value?.some((user) => user?.id == props?.user?.id))
    setFilteredData(filtered);
    // setInData(filtered)
  }

  const handleClear = () => {
    setClientData({
      projectStatus: { value: 'Hide Completed Task', label: 'Hide Completed Task' },
      searchTerm: "",
      employeename: ""
    });
    setSearchTerm("");
    setSelectedStatus({ value: 'Hide Completed Task', label: 'Hide Completed Task' });
    setDateStatus(false);
    setIsMyTaskList(false);
    setFilteredData([]);
    setFilteredStartDate(null);
    setFilteredEndDate(null);
    setTimeout(() => {
      applyFilters({ status: { value: 'Hide Completed Task', label: 'Hide Completed Task' }, search: "" });
    }, 0);
  }

  const shouldShowClearButton = () => {
    const hasSearchTerm = searchTerm;
    const hasDateFilter = dateStatus;
    const hasMyTaskFilter = isMytaskList;
    const hasNonDefaultStatus = selectedStatus && selectedStatus.value !== 'Hide Completed Task';

    return hasSearchTerm || hasDateFilter || hasMyTaskFilter || hasNonDefaultStatus;
  };
  return (
    <div className="empTask-main">
      <div className="page-title">
        {
          props.loading ? (
            <Skeleton className='rounded-2' width={200} height={40} />
          ) : (
            <h4> Tasks </h4>
          )
        }
        <div>
          {
            props.loading ? (
              <Skeleton className='badge rounded-pill' width={50} height={40} />
            ) : (
              <RoleWiseFeatureWrapper
                modules={props?.modules}
                features={props?.features}
                user={props?.user}
                ModuleName={ModulesList.Task}
                Featur_Name={FeaturesList.Create}>

                <button
                  className="custom-emptask-btn"
                  disabled={props.loading}
                  onClick={handleAddClick}
                >
                  Add Task
                </button>
              </RoleWiseFeatureWrapper>
            )
          }
        </div>
      </div>

      <div className="row">
        <div className="col-lg-4">
          {
            props.loading ? (
              <Skeleton className='rounded-2' width="100%" height={40} />
            ) : (
              <div className="input-group">
                <CustomCalendar
                  inData={inData}
                  setFilteredData={setFilteredData}
                  selectedStatus={selectedStatus}
                  searchTerm={searchTerm}
                  applyFilters={(params) => { applyFilters(params) }}
                  startDate={filteredStartDate}
                  endDate={filteredEndDate}
                  setStartDate={setFilteredStartDate}
                  setEndDate={setFilteredEndDate}
                />
              </div>
            )
          }
        </div>

        <div className="col-lg-3">
          {
            props.loading ? (
              <Skeleton className='rounded-2' width="100%" height={40} />
            ) : (
              <div className="input-group">
                <Select
                  options={Status?.slice()?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))}
                  styles={{
                    ...customStyle,
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 2,
                    }),
                  }}
                  value={clientData.projectStatus}
                  placeholder="Status"
                  onChange={(val) => handleSelectStatusChange(val)}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: '#5757fe',
                      primary: '#5757fe',
                    },
                  })}
                  isClearable={true}
                />
              </div>
            )
          }
        </div>

        <div className="col-lg-4">
          {
            props.loading ? (
              <Skeleton className='rounded-2' width="100%" height={40} />
            ) : (
              <div className="input-group">
                <input
                  type="text"
                  className="input-css"
                  name="employeename"
                  placeholder="Search Task"
                  value={clientData?.employeename || ""}
                  onChange={searchFiled}
                />
              </div>
            )
          }
        </div>
        <div className='col-lg-1'>
          <div className="input-group">
            {shouldShowClearButton() && (
              props.loading ? (
                <Skeleton className='rounded-2' width="100%" height={40} />
              ) : (
                <button
                  className="custom-emptask-btn"
                  disabled={props.loading}
                  onClick={handleClear}
                >Clear
                </button>
              )
            )}
          </div>
        </div>
      </div>

      <div className="emptask-export-btn">
        <div>

          {
            props.loading ? (
              <Skeleton className='badge rounded-pill' width={100} height={40} />
            ) : (
              <button className="custom-emptask-btn" disabled={props.loading} onClick={handleFetchUserTasks}>
                My Task
              </button>
            )
          }

          {
            props.loading ? (
              <Skeleton className='badge rounded-pill' width={100} height={40} />
            ) : (
              <button
                className="export-btn"
                id="exportBtn"
                disabled={!checked || exportLoading}
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(totalSelectedIds, 'export');
                }}
              >
                Export
              </button>
            )
          }

        </div>

        <div>
          {
            props.loading ? (
              <Skeleton className='rounded-2' width={50} height={40} />
            ) : (
              <div className="navigation_btn">
                <button
                  className={`btn1 ${activeButton === 'emptask' ? 'active' : ''}`}
                  onClick={() => clickButton('emptask', '/task/emptask')}
                >
                  <TaskIcon
                    color={activeButton === 'emptask' ? 'white' : 'black'}
                    bgColor={activeButton === 'emptask' ? 'black' : 'white'}
                  />
                </button>
                <button
                  className={`btn1 ${activeButton === 'emptaskboard' ? 'active' : ''}`}
                  onClick={() => clickButton('emptaskboard', '/task/emptaskboard')}
                >
                  <TaskBoardIcon
                    color={activeButton === 'emptaskboard' ? 'white' : 'black'}
                    bgColor={activeButton === 'emptaskboard' ? 'black' : 'transparent'}
                  />
                </button>
                <button
                  className={`btn1 ${activeButton === 'emptaskcalendar' ? 'active' : ''}`}
                  onClick={() => clickButton('emptaskcalendar', '/task/emptaskcalendar')}
                >
                  <TaskCalendarIcon
                    color={activeButton === 'emptaskcalendar' ? 'white' : 'black'}
                    bgColor={activeButton === 'emptaskcalendar' ? 'black' : 'white'}
                  />
                </button>
              </div>
            )
          }
        </div>
      </div>

      <div className="invoice-table-part">
        {
          props.loading ? (
            <Skeleton className='rounded-2' count={5} width="100%" height={40} />
          ) : (
            <Table
              header={header}
              data={(searchTerm || selectedStatus || dateStatus || isMytaskList) ? filteredData : inData}
              footer={footer}
              count={count}
              records={count}
              defaultParams={params}
              totalSelectedIds={totalSelectedIds}
              handleChange={handleChange}
              showIsView={canView}
              updateTask={props?.updateTask}
              deleteRecord={props?.deleteRecord}
              user={props?.user}
              TaskStatus={Status}
            />
          )
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.taskReducer.loading,
    task: state.taskReducer.task,
    modules: state.authenticationReducer.modules,
    features: state.authenticationReducer.features,
    user: state.authenticationReducer.user,
    updateTaskTimerData: state.taskReducer.updateTask,
    taskStatus: state.taskReducer.taskStatus,
    dashboardData: state.dashboardReducer.dashboardData,
    project: state.projectReducer.project,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getTasks: () => {
      dispatch(getTasks())
    },
    updateTask: (id, data, showToast) => {
      dispatch(updateTask(id, data, showToast))
    },
    deleteRecord: async (id, inputValue) => {
      await dispatch(deleteRecord(id, inputValue))
      await dispatch(getTasks())
    },
    getTaskStatus: () => {
      dispatch(getTaskStatus());
    },
    getDashboardData: (id) => {
      dispatch(getDashboardData(id))
    },
    getprojects: (id) => {
      dispatch(getprojects())
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(EmpTask);
